import { render } from "./HotPaste.vue?vue&type=template&id=993c432e"
import script from "./HotPaste.vue?vue&type=script&lang=js"
export * from "./HotPaste.vue?vue&type=script&lang=js"

import "./HotPaste.vue?vue&type=style&index=0&id=993c432e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__